import React from 'react';
import StatusOval from '../components/StatusOval';

const svgStyle = {display: 'block', fontFamily: "'Geist', sans-serif", width: '100%', height: 'auto'};

export const UploadDiagramIllustrationDesktop = () => (
    <svg width="640" height="380" viewBox="0 0 640 380" aria-hidden="true" style={svgStyle}>
        <g transform="rotate(-5 320 190)">
            <rect x="130" y="60" width="380" height="250" rx="16" fill="#F1EFE8" stroke="#E1DED5" strokeWidth="2"/>
        </g>
        <g transform="rotate(3 320 190)">
            <rect x="120" y="50" width="400" height="260" rx="16" fill="#FFFFFF" stroke="#141416" strokeWidth="2"/>
            <g fill="#D9D6CC">
                <rect x="160" y="78" width="70" height="8" rx="4"/>
                <rect x="290" y="78" width="70" height="8" rx="4"/>
                <rect x="420" y="78" width="70" height="8" rx="4"/>
            </g>
            <g stroke="#C9C6BC" strokeWidth="3" strokeLinecap="round">
                <line x1="195" y1="100" x2="195" y2="286"/>
                <line x1="325" y1="100" x2="325" y2="286"/>
                <line x1="455" y1="100" x2="455" y2="286"/>
            </g>
            <g fill="none" stroke="#8A877E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M200 130 H 316"/>
                <path d="M308 123 L316 130 L308 137"/>
                <path d="M330 180 H 446"/>
                <path d="M438 173 L446 180 L438 187"/>
                <path d="M450 230 H 334"/>
                <path d="M342 223 L334 230 L342 237"/>
            </g>
            <g fill="none" stroke="#A9A69C" strokeWidth="2.5" strokeDasharray="6 7" strokeLinecap="round">
                <path d="M320 262 H 206"/>
            </g>
        </g>
        <g transform="translate(404 300)">
            <rect width="196" height="48" rx="24" fill="#141416"/>
            <g transform="translate(18 14)" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"
               strokeLinejoin="round">
                <path d="M10 14V2M5 7l5-5 5 5M2 14v4h16v-4"/>
            </g>
            <text x="48" y="30" fontSize="14" fontWeight="600" fill="#FFFFFF">Upload a diagram</text>
        </g>
    </svg>
);

export const UploadDiagramIllustrationMobile = () => (
    <svg width="326" height="220" viewBox="0 0 326 220" aria-hidden="true" style={svgStyle}>
        <g transform="rotate(-5 163 104)">
            <rect x="46" y="30" width="236" height="150" rx="12" fill="#F1EFE8" stroke="#E1DED5" strokeWidth="2"/>
        </g>
        <g transform="rotate(3 163 104)">
            <rect x="40" y="24" width="246" height="160" rx="12" fill="#FFFFFF" stroke="#141416" strokeWidth="2"/>
            <g fill="#D9D6CC">
                <rect x="68" y="42" width="44" height="6" rx="3"/>
                <rect x="141" y="42" width="44" height="6" rx="3"/>
                <rect x="214" y="42" width="44" height="6" rx="3"/>
            </g>
            <g stroke="#C9C6BC" strokeWidth="2.5" strokeLinecap="round">
                <line x1="90" y1="58" x2="90" y2="168"/>
                <line x1="163" y1="58" x2="163" y2="168"/>
                <line x1="236" y1="58" x2="236" y2="168"/>
            </g>
            <g fill="none" stroke="#8A877E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M94 78 H 157"/>
                <path d="M151 73 L157 78 L151 83"/>
                <path d="M167 110 H 230"/>
                <path d="M224 105 L230 110 L224 115"/>
                <path d="M232 142 H 169"/>
                <path d="M175 137 L169 142 L175 147"/>
            </g>
        </g>
        <g transform="translate(146 170)">
            <rect width="164" height="40" rx="20" fill="#141416"/>
            <g transform="translate(14 11)" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"
               strokeLinejoin="round">
                <path d="M9 12V2M5 6l4-4 4 4M2 12v4h14v-4"/>
            </g>
            <text x="40" y="25" fontSize="13" fontWeight="600" fill="#FFFFFF">Upload a diagram</text>
        </g>
    </svg>
);

export const NamePageIllustrationDesktop = () => (
    <svg width="560" height="340" viewBox="0 0 560 340" aria-hidden="true" style={svgStyle}>
        <text x="40" y="36" fontSize="14" fontWeight="600" fill="#45444B">Page name</text>
        <rect x="36" y="50" width="488" height="60" rx="14" fill="none" stroke="#3346E0" strokeOpacity="0.25"
              strokeWidth="6"/>
        <rect x="36" y="50" width="488" height="60" rx="14" fill="#FFFFFF" stroke="#3346E0" strokeWidth="2"/>
        <text x="60" y="87" fontSize="18" fontWeight="500" fill="#141416">Checkout revamp — payment flow</text>
        <rect x="352" y="68" width="2" height="26" fill="#141416"/>
        <text x="40" y="160" fontFamily="'Geist Mono', monospace" fontSize="12" letterSpacing="0.08em" fill="#8A887F">
            YOUR PAGES
        </text>
        <rect x="36" y="176" width="488" height="46" rx="12" fill="#F1F2FE"/>
        <g transform="translate(56 190)">
            <rect width="16" height="18" rx="3" fill="none" stroke="#3346E0" strokeWidth="1.8"/>
        </g>
        <text x="86" y="204" fontSize="15" fontWeight="600" fill="#141416">Checkout revamp — payment flow</text>
        <text x="504" y="204" fontSize="13" fill="#3346E0" textAnchor="end">New</text>
        <g transform="translate(56 240)">
            <rect width="16" height="18" rx="3" fill="none" stroke="#8A887F" strokeWidth="1.8"/>
        </g>
        <text x="86" y="254" fontSize="15" fill="#45444B">Onboarding emails v2</text>
        <line x1="36" y1="274" x2="524" y2="274" stroke="#ECEAE3"/>
        <g transform="translate(56 290)">
            <rect width="16" height="18" rx="3" fill="none" stroke="#C4C1B8" strokeWidth="1.8"/>
        </g>
        <text x="86" y="304" fontSize="15" fill="#A9A69C">Page 1</text>
        <text x="504" y="304" fontSize="13" fill="#A9A69C" textAnchor="end">Which one was this?</text>
    </svg>
);

export const NamePageIllustrationMobile = () => (
    <svg width="326" height="220" viewBox="0 0 326 220" aria-hidden="true" style={svgStyle}>
        <text x="14" y="22" fontSize="13" fontWeight="600" fill="#45444B">Page name</text>
        <rect x="12" y="34" width="302" height="50" rx="12" fill="none" stroke="#3346E0" strokeOpacity="0.25"
              strokeWidth="5"/>
        <rect x="12" y="34" width="302" height="50" rx="12" fill="#FFFFFF" stroke="#3346E0" strokeWidth="2"/>
        <text x="28" y="64" fontSize="14" fontWeight="500" fill="#141416">Checkout revamp — payment flow</text>
        <rect x="258" y="49" width="2" height="20" fill="#141416"/>
        <text x="14" y="116" fontFamily="'Geist Mono', monospace" fontSize="11" letterSpacing="0.08em" fill="#8A887F">
            YOUR PAGES
        </text>
        <rect x="12" y="128" width="302" height="40" rx="10" fill="#F1F2FE"/>
        <rect x="26" y="139" width="14" height="16" rx="3" fill="none" stroke="#3346E0" strokeWidth="1.6"/>
        <text x="50" y="153" fontSize="13" fontWeight="600" fill="#141416">Checkout revamp — pay…</text>
        <text x="300" y="153" fontSize="12" fill="#3346E0" textAnchor="end">New</text>
        <rect x="26" y="185" width="14" height="16" rx="3" fill="none" stroke="#C4C1B8" strokeWidth="1.6"/>
        <text x="50" y="198" fontSize="13" fill="#A9A69C">Page 1</text>
        <text x="300" y="198" fontSize="12" fill="#A9A69C" textAnchor="end">Which one was this?</text>
    </svg>
);

export const TaskOutIllustrationDesktop = () => (
    <svg width="640" height="380" viewBox="0 0 640 380" aria-hidden="true" style={svgStyle}>
        <g stroke="#E1DED5" strokeWidth="3" strokeLinecap="round">
            <line x1="150" y1="40" x2="150" y2="344"/>
            <line x1="320" y1="40" x2="320" y2="344"/>
            <line x1="490" y1="40" x2="490" y2="344"/>
        </g>
        <g fill="none" stroke="#8A877E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M226 84 C 270 84, 262 142, 240 142"/>
            <path d="M396 146 C 440 146, 432 208, 414 208"/>
            <path d="M320 172 L 320 236"/>
        </g>
        <g fill="none" stroke="#A9A69C" strokeWidth="2.5" strokeDasharray="6 7" strokeLinecap="round">
            <path d="M414 214 C 440 214, 432 290, 412 290"/>
        </g>
        <StatusOval cx={150} cy={84} rx={76} ry={28} status="todo" label="Validate card" fontSize={14}/>
        <StatusOval cx={320} cy={146} rx={76} ry={28} status="todo" label="Call provider" fontSize={14}/>
        <StatusOval cx={490} cy={210} rx={76} ry={28} status="todo" label="Show receipt" fontSize={14}/>
        <StatusOval cx={320} cy={264} rx={76} ry={28} status="todo" label="Handle errors" fontSize={14}/>
        <path d="M254 312 C 180 318, 160 350, 250 352 C 340 354, 420 338, 408 318" fill="none" stroke="#3346E0"
              strokeWidth="2.5" strokeLinecap="round"/>
        <text x="320" y="340" fontSize="14" fontWeight="500" fill="#8A887F" textAnchor="middle">Retry payment</text>
        <g transform="translate(404 300) rotate(-35)">
            <rect x="-4" y="-30" width="12" height="30" rx="2" fill="#141416"/>
            <path d="M-4 0 L2 12 L8 0 Z" fill="#141416"/>
        </g>
    </svg>
);

export const TaskOutIllustrationMobile = () => (
    <svg width="326" height="224" viewBox="0 0 326 224" aria-hidden="true" style={svgStyle}>
        <g stroke="#E1DED5" strokeWidth="2.5" strokeLinecap="round">
            <line x1="70" y1="14" x2="70" y2="214"/>
            <line x1="163" y1="14" x2="163" y2="214"/>
            <line x1="256" y1="14" x2="256" y2="214"/>
        </g>
        <g fill="none" stroke="#8A877E" strokeWidth="2" strokeLinecap="round">
            <path d="M122 44 C 146 44, 140 100, 113 100"/>
            <path d="M215 102 C 238 102, 233 156, 206 156"/>
        </g>
        <path d="M163 122 L 163 172" fill="none" stroke="#A9A69C" strokeWidth="2" strokeDasharray="5 6"/>
        <StatusOval cx={70} cy={44} rx={52} ry={20} status="todo" label="Validate card" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={163} cy={100} rx={52} ry={20} status="todo" label="Call provider" fontSize={12} strokeWidth={2.2}/>
        <StatusOval cx={256} cy={156} rx={52} ry={20} status="todo" label="Show receipt" fontSize={12} strokeWidth={2.2}/>
        <path d="M130 180 C 100 186, 104 208, 160 208 C 214 208, 226 194, 212 182" fill="none" stroke="#3346E0"
              strokeWidth="2.2" strokeLinecap="round"/>
        <text x="163" y="199" fontSize="12" fontWeight="500" fill="#8A887F" textAnchor="middle">Handle errors</text>
        <g transform="translate(212 182) rotate(-35)">
            <rect x="-3" y="-24" width="10" height="24" rx="2" fill="#141416"/>
            <path d="M-3 0 L2 10 L7 0 Z" fill="#141416"/>
        </g>
    </svg>
);
